import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  hasResources: {
    id: 'studio.AE1+0n',
    defaultMessage: 'This app has the following resources:',
  },
  noResources: {
    id: 'studio.i/TW7n',
    defaultMessage: 'This app has no resources.',
  },
});
